import React from 'react';

import * as StyledComponent from '../../style/modalsStyle';
import backgroundPlaceholder from '../../../../assets/images/actorbg.png';
import * as palette from '../../../../components/General/Variables';
import useAccessibleElement from '../../../../hooks/useAccessibleElement';

export const BackgroundAndAvatar = ({ theme, fieldValues, onImageChange, authUser }) => {
    useAccessibleElement({
        ariaControls: 'background-image-filename',
        inputElementId: 'background-image-upload',
    });
    useAccessibleElement({
        ariaControls: 'profile-image-filename',
        inputElementId: 'profile-image-upload',
    });

    return (
        <React.Fragment>
            <StyledComponent.BackgroundImageWrapper>
                <StyledComponent.BackgroundImage
                    src={fieldValues.coverUrl ? fieldValues.coverUrl : backgroundPlaceholder}
                />
                <StyledComponent.BackgroundInputWrapper>
                    <label htmlFor="background-image-upload">
                        <span role="button" aria-controls="background-image-filename" tabIndex="0">
                            <StyledComponent.AddImage primarycolor={theme.primary}>
                                {palette.ADD_PHOTO}
                            </StyledComponent.AddImage>
                        </span>
                    </label>
                    <input
                        id="background-image-upload"
                        name="coverUrl"
                        type="file"
                        accept="image/*"
                        onChange={onImageChange}
                    />
                </StyledComponent.BackgroundInputWrapper>
            </StyledComponent.BackgroundImageWrapper>

            <StyledComponent.ProfileImageWrapper>
                <StyledComponent.EurekaAvatar
                    avatarcolor={authUser.userColor}
                    src={fieldValues.imageUrl}
                    role="presentation"
                >
                    {`${authUser.firstName[0]}${authUser.lastName[0]}`}
                </StyledComponent.EurekaAvatar>
                <StyledComponent.ProfileInputWrapper>
                    <label htmlFor="profile-image-upload">
                        <span role="button" aria-controls="profile-image-filename" tabIndex="0">
                            <StyledComponent.AddImage primarycolor={theme.primary}>
                                {palette.ADD_PHOTO}
                            </StyledComponent.AddImage>
                        </span>
                    </label>
                    <input
                        id="profile-image-upload"
                        name="imageUrl"
                        type="file"
                        accept="image/*"
                        onChange={onImageChange}
                    />
                </StyledComponent.ProfileInputWrapper>
            </StyledComponent.ProfileImageWrapper>
        </React.Fragment>
    );
};
